module.exports = "https://www.gc-qa.gnp.com.mx/4d2a7cf02576c8d9d6e4d8fa2eb9e0d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/no-vacunacion.svg
// module id = 1852
// module chunks = 0